import { Subscribe } from "./Footer"


const BgImg = require("../assets/images/hero-bg.jpg")
const Hero = ()=> {
    const carouselList = {
      "Eliminate troubles with stock-report": {icon:"bi bi-clipboard-data", note: "With Hotelace, the need for manual stock-record, stock-transfer, sales-summary and reporting, is eliminated..."},
      "Automate requisitions & issuances": {icon:"bi bi-cart", note: "With Hotelace, requisitions & issuances are automatically controlled, adding & subtracting stocks, from store, to outlets."},
      "Automate accounting procedures": {icon:"bi bi-book", note: "Hotelace provides reports on expenditures, purchases, payroll etc amongst other reports, to facilitate required statements & operational forecasting"},
      "Optimise front-office operations": {icon:"bi bi-binoculars", note: "from reporting to casheering, merging & spltting bills, invoicing, forecasting etc Hotelace provides controlled features, to automate these processes & more"},
      "Optmise f&b operations": {icon:"bi bi-gem", note: "Hotelace is empowered to cater for hospitality outlets, from order & credit posting, strock-recording, issunace, requisitions etc all of these requirements are automated & synchronised with other departments."},
      "Synchronise departmental operations": {icon:"bi bi-inboxes", note: "With Hotelace, outlets, front-office, store etc, are synchronised, with reports and controls automated in real-time."},
    }
    const points = {
      "Automated records":"Dependence on or reference to manual record, is eliminated or barely needed.",
      "Modular cohesion": "Syncronise departments & outlets by enabling operational cohesion",
      "Stock accuracy": "Eliminate the burden of error in stock reporting, sales, requisitions, store-issuances, stock-sharing, transfers etc. Hotelace provides cohesive features to cater for all these.",
      "Invoicing & billing": "With Hotelace, bills & invoices are automatically computed, in real-time",
      "Accounting": "Hotealce can help in tracking purchases, payroll, expenditures, statements, etc thereby, facilitating proper planning.",
      "Modular cohesions": "Syncronise departments by eliminating the need for departments to",
      "Controls": "Hotelace provisions several decision rules for controls, thereby automating permissions & access",
    }
    
    return(
      <section id="hero" className="hero section dark-background">

      <img src={BgImg} alt="" data-aos="fade-in" />

      <div className="container position-relative">

        <div className="welcome position-relative" data-aos="fade-down" data-aos-delay="100">
          <h2>Hotelace</h2>
          <p>The ease & peace of automating hospitality operations</p>
        </div>

        <div className="content row gy-4">
          <div className="col-lg-4 d-flex align-items-stretch">
            <div className="why-box" data-aos="zoom-out" data-aos-delay="200">
              <h3 style={{fontSize: "18px"}}>Operationally simulated, for optimisation.</h3>
              <p>
                Operating manually, is quite exhausting & error-prone, with a lot confusing reference to paper work, over time.
                But, with Hotelace,  
                <ul>
                  {
                    Object.keys(points).map(pt => (
                      <li key={pt}> 
                        <span style={{fontWeight: "bold", color: "#000"}}>{pt}: </span>
                        <span>{(points as any)[pt]}</span>
                      </li>
                    ))
                  }
                  {/* <li><i className="bi bi-check2-all"></i> <span>Modular cohesion</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Detailed reporting</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Operational prompting to eliminate possible errors</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Ease of use, with keynotes for guide</span></li> */}
                </ul>
              </p>
              <div className="text-center">
                <a href="#" className="more-btn"><span>Get Started</span> <i className="bi bi-chevron-right"></i></a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 d-flex align-items-stretch">
            <div className="d-flex flex-column justify-content-center">
              <div className="row gy-4">
                {
                  Object.keys(carouselList).map(str => (
                    <div key={str} className="col-xl-4 d-flex align-items-stretch">
                      <div className="icon-box" data-aos="zoom-out" data-aos-delay="300">
                        <i className={(carouselList as any)[str].icon}></i>
                        <h4 style={{fontSize: "15px"}}>{str}</h4>
                        <p>{(carouselList as any)[str].note}</p>
                      </div>
                    </div>
                  ))
                }       

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    )
}

export default Hero